// Wire contract — imports history INPUT schemas (the per-project reader over
// import_jobs / import_job_rows, Tier-2 of the audit model — ADR-020/ADR-041).
import { z } from 'zod';
import { PaginationSchema } from '../common/pagination.js';
// Runs accumulate for the deployment's lifetime (bounded thousands; admin
// random-access UX) → OFFSET pagination (CONVENTIONS §Pagination).
export const ListImportsQuerySchema = PaginationSchema.extend({
    entity_type: z.string().trim().max(64).optional(),
    status: z.enum(['running', 'committed', 'failed']).optional(),
}).strict();
export const ImportJobParamsSchema = z
    .object({ projectId: z.string().min(1).max(16), jobId: z.string().min(1).max(16) })
    .strict();
// Per-row detail: the errors-only filter is the common read.
export const ListImportRowsQuerySchema = PaginationSchema.extend({
    outcome: z.enum(['create', 'update', 'skip', 'error']).optional(),
}).strict();
